export const BRAND_LOGO_URL = "https://customer-assets-cm19k8pv.emergentagent.net/job_crew-scheduler-84/artifacts/3gbz598f_WhatsApp%20Image%202026-10-01%20at%2016.10.03.jpeg";
